import React from "react";
import { DotLegalCurrencyAmountField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import useCountryCurrencyHook, { defaultCurrencyCode } from "@common/hooks/useCountryCurrencyList.ts";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider.tsx";

export interface IncidentLogEstimatedFinancialLossFieldProps {
    amount?: number | null;
    currencyCode?: string | null;
    onChange: (amount: number | null, currencyCode: string | null) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogEstimatedFinancialLossField(props: IncidentLogEstimatedFinancialLossFieldProps) {
    const { translateString } = useTranslation();
    const { language } = useUserContext();
    const { getCurrenciesAsIsoCodes } = useCountryCurrencyHook();
    const shownCurrencyCode = props.currencyCode ?? defaultCurrencyCode;

    return (
        <DotLegalCurrencyAmountField
            amountLabel={translateString("incidentLogEstimatedFinancialLoss")}
            amount={props.amount?.toString()}
            // The shown currency is saved with every amount change, so an amount never lands without the currency the
            // user sees next to it, and clearing the amount keeps the currency they picked for when they type a new one.
            onAmountChange={(value) => props.onChange(value ? parseFloat(value) : null, shownCurrencyCode)}
            onCurrencyChange={(value) => props.onChange(props.amount ?? null, value)}
            currency={shownCurrencyCode}
            currencyOptions={props.isPreview ? [] : getCurrenciesAsIsoCodes()}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            debounce
            amountErrorText={props.errorText}
            seperatorStyle={language === "en" ? "en" : "da"}
        />
    );
}

export default IncidentLogEstimatedFinancialLossField;
